import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentMasteryTestErrorRateSummary = (props) => (
  <KpiSummary
    title="Error report"
    formatter={props.formatter}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    isLoading={props.isLoading}
  />
);

ContentMasteryTestErrorRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentMasteryTestErrorRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentMasteryTestErrorRateSummary;
